/* First-party order metadata; no customer identity, pixel, or purchase emission. */
(function (window, document) {
  'use strict';
  if (window.hbAnalyticsCart || !window.hbAnalyticsProviders) return;
  var provider = window.hbAnalyticsProviders, chain = Promise.resolve(true), saved = null;
  function attributes() {
    var s = provider.getSnapshot();
    return {
      __hb_analytics_consent: s ? 'v1:granted' : 'v1:denied',
      __hb_visitor_id: s ? s.visitor_id : '',
      __hb_ga_client_id: s && s.ga_client_id || '',
      __hb_ga_id_source: s && s.ga_id_source || ''
    };
  }
  function formFields(form) {
    try {
      var url = new URL(form.action, window.location.href);
      if (url.origin !== window.location.origin || !/\/cart\/?$/.test(url.pathname)) return;
      var values = attributes();
      Object.keys(values).forEach(function (key) {
        var name = 'attributes[' + key + ']';
        var field = form.querySelector('input[name="' + name + '"]');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.appendChild(field); }
        field.value = values[key];
      });
    } catch (_) { /* Never interrupt checkout. */ }
  }
  function refresh() {
    chain = chain.then(async function () {
      // Read inside the queue: revoked identity must not survive queued work.
      var values = attributes(), signature = JSON.stringify(values);
      if (signature === saved) return true;
      try {
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        var response = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes: values})
        });
        if (!response.ok) return false;
        saved = signature; return true;
      } catch (_) { return false; }
    }).catch(function () { return false; });
    return chain;
  }
  window.hbAnalyticsCart = {refresh: refresh, flush: function () { return chain; }};
  provider.subscribe(function () {
    document.querySelectorAll('form[action]').forEach(formFields);
    refresh();
  });
  document.addEventListener('submit', function (event) { formFields(event.target); }, true);
})(window, document);
